import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { PaymentDetailsPayload } from '../../TransactionDetails.types';
import { getDirectDepositInfo, getFormattedData } from '../utils/paymentDetails.utils';

const QUERY_KEY = (postingId?: string) => `activities_postings_payment_details_by_posting_id-${postingId}`;

interface Args {
  postingId?: string;
  isLockboxTransaction?: boolean;
}

export const useGetLockboxPaymentDetails = (params: Args) => {
  const query = useQuery(
    [QUERY_KEY(params.postingId), params.postingId],
    () => {
      if (!params.postingId || !params.isLockboxTransaction) return null;
      return api.get<PaymentDetailsPayload>(
        API_URL.ACTIVITIES_POSTINGS_PAYMENT_DETAILS_BY_POSTING_ID(params.postingId)
      );
    },
    {
      enabled: false,
      cacheTime: 0,
      retry: 0,
    }
  );

  const refetch = () => {
    if (params.postingId && params.isLockboxTransaction) {
      return query.refetch();
    }
    return;
  };

  const formattedData = query.data ? getFormattedData(query.data.data) : undefined;
  const directDepositInfo = query.data ? getDirectDepositInfo(query.data.data) : undefined;

  return {
    ...query,
    formattedData,
    directDepositInfo,
    refetch,
  };
};
export default useGetLockboxPaymentDetails;
